import { createFileRoute } from "@tanstack/react-router";
import { ResidencePage } from "@/views/public/residence/ResidencePage.tsx";

export const Route = createFileRoute("/_public/residence")({
  component: ResidencePage,
});
